<mat-dialog-title><b>Belge Kullanım Adetleri</b></mat-dialog-title>
<br />
<mat-card-subtitle></mat-card-subtitle>
<mat-dialog-content>
  <div>
    <ejs-grid
      #gridMonthly
      id="gridMonthly"
      [allowGrouping]="true"
      [groupSettings]="groupOptions"
      [dataSource]="dailyDocumentCountData"
      [rowHeight]="35"
      [gridLines]="gridLines"
      [allowExcelExport]="true"
      (toolbarClick)="toolbarClick($event)"
      [toolbar]="toolbarOptions"
    >
      <e-columns>
        <e-column
          field="documentType"
          headerText="Hizmet"
          width="50"
        ></e-column>
        <e-column field="documentDirection" headerText="YÖN" width="50">
          <ng-template #template let-dailyDocumentCountData>
            <div
              *ngIf="dailyDocumentCountData.documentDirection === 'Outgoing'"
            >
              <mat-icon color="primary" style="margin-left: -9px"
                >call_made</mat-icon
              >
              <span>Giden</span>
            </div>
            <div
              *ngIf="dailyDocumentCountData.documentDirection === 'Incoming'"
            >
              <mat-icon color="primary" style="margin-left: -9px"
                >call_received</mat-icon
              >
              <span>Gelen</span>
            </div>
          </ng-template>
        </e-column>
        <e-column field="year" headerText="YIL" width="50"></e-column>
        <e-column field="month" headerText="AY" width="50"></e-column>
        <e-column field="totalCount" headerText="BELGE SAYISI" width="50">
        </e-column>
      </e-columns>
      <e-aggregates>
        <e-aggregate>
          <e-columns>
            <e-column field="totalCount" type="sum">
              <ng-template #groupFooterTemplate let-dailyDocumentCountData
                >Sum: {{ dailyDocumentCountData.sum }}</ng-template
              >
            </e-column>
            <!-- <e-column field="totalCount" type="max">
              <ng-template #groupCaptionTemplate let-dailyDocumentCountData
                >Max: {{ dailyDocumentCountData.max }}</ng-template
              >
            </e-column> -->
          </e-columns>
        </e-aggregate>
      </e-aggregates>
    </ejs-grid>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 0">
  <button mat-raised-button matDialogClose color="primary">KAPAT</button>
</mat-dialog-actions>
